import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges, TemplateRef, ViewChild } from '@angular/core';
import * as XLSX from 'xlsx';
//import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Router } from '@angular/router';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';

import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'biz-grid',
  templateUrl: './biz-grid.component.html',
  styleUrls: ['./biz-grid.component.scss']
})
export class BizGridComponent implements OnChanges {
  @Input() gridColumnDetails: any[] = [];
  @Input() gridDataDetails: any[] = [];
  @Input() removeColumn: string = '';
  @Input() showSearch: boolean = true;
  @Input() selectedGroupColumn: string = '';
  @Input() ProductDataDetails: any[] = [];
  @Input() ProductColumnDetails: any[] = [];
  @Output() cellDrilldown = new EventEmitter<{ column: string, value: any }>();

  groupedData: any[] = [];
  searchText: string = '';
  filteredData: any[] = [];
  BreakUPBtn: any[] = [];
  totalRow: any = {};
  columnWidths: number[] = [];
  activeFilters: { column: string; value: string }[] = [];
  chartOptions: any;
  showChart = false;
  selectedChartType = 'bar';
  selectedNumericColumn = '';
  selectedDateColumn = '';
  showGraphType: boolean = false;
  showNumericColum: boolean = false;
  showMakeGraph: boolean = false;
  freezeCount: number = 0;
  originalGroupedData: any[] = [];
  // modalRef: any;

  modalRef!: NgbModalRef;


  constructor(
    // private modalService: BsModalService,
    private router: Router,
    private modalService: NgbModal
  ) { };
  @ViewChild('detailModal') detailModal: TemplateRef<any>;
  initialize(): void {
    this.removeColumnByName();
    this.filteredData = [...this.gridDataDetails];
    this.calculateColumnWidths();
    this.applyTotalRow();
  };


  showFreezeOptions = false;
  toggleFreezeOptions() {
    this.showFreezeOptions = !this.showFreezeOptions;
    if (!this.showFreezeOptions) {
      this.frozenColumns.clear();
    }
  }

  frozenColumns: Set<number> = new Set<number>();

  toggleFreezeColumn(event: any, colIndex: number) {
    if (event.target.checked) {
      this.frozenColumns.add(colIndex);
    } else {
      this.frozenColumns.delete(colIndex);
    }
  }

  isColumnFrozen(index: number): boolean {
    return this.frozenColumns.has(index);
  }

  getLeftOffset(index: number): number {
    let offset = 0;
    for (let i = 0; i < index; i++) {
      if (this.frozenColumns.has(i)) {
        offset += this.columnWidths[i] || 100;
      }
    }
    return this.frozenColumns.has(index) ? offset : null as any;
  }

  groupColumns: string[] = ['category', 'subCategory', 'code', 'producttitle'];
  expandedParent: any = null;


  expandedGroup: any = null;

  toggleGroup(group: any) {
    if (this.expandedGroup === group) {
      this.expandedGroup = null; // collapse
    } else {
      this.expandedGroup = group; // expand
    }
  }

  // flags
  showGroupByOptions = false;
  isGrouped = false;
  selectedGroupBy: string[] = [];
  // groupedData: any[] = [];

  toggleGroupByOptions() {
    this.showGroupByOptions = !this.showGroupByOptions;

    if (!this.showGroupByOptions) {
      this.selectedGroupBy = [];
      this.groupedData = [];
      this.isGrouped = false;
    }
  }


  onGroupByChange(col: string, event: any) {
    const colIndex = this.gridColumnDetails.findIndex(c => c.prop === col);

    if (event.target.checked) {
      this.selectedGroupBy = this.gridColumnDetails
        .slice(0, colIndex + 1)
        .map(c => c.prop);
    } else {
      this.selectedGroupBy = this.gridColumnDetails
        .slice(0, colIndex)
        .map(c => c.prop);
    }

    if (this.selectedGroupBy.length > 0) {
      // ✅ Sort data by first group column before grouping
      this.sortColumn = this.selectedGroupBy[0];
      this.sortDirection = 'asc';
      const sortedData = this.SortData(this.filteredData);

      // ✅ Perform grouping
      this.groupedData = this.groupData(sortedData, this.selectedGroupBy);
      this.originalGroupedData = JSON.parse(JSON.stringify(this.groupedData));

      // ✅ Sort each group's child rows by first *non-grouped* column
      const nonGroupedCols = this.gridColumnDetails
        .map(c => c.prop)
        .filter(p => !this.selectedGroupBy.includes(p));

      const childSortColumn = nonGroupedCols.length ? nonGroupedCols[0] : null;

      if (childSortColumn) {
        this.groupedData.forEach(group => {
          if (group.childRows && group.childRows.length > 0) {
            group.childRows.sort((a: any, b: any) => {
              const valueA = a[childSortColumn] ?? '';
              const valueB = b[childSortColumn] ?? '';
              const isDate = childSortColumn.toLowerCase().includes('date');

              if (isDate) {
                return new Date(valueA).getTime() - new Date(valueB).getTime();
              } else if (typeof valueA === 'number' && typeof valueB === 'number') {
                return valueA - valueB;
              } else {
                return valueA.toString().localeCompare(valueB.toString(), undefined, { numeric: true });
              }
            });
          }
        });
      }

      this.isGrouped = true;
    } else {
      this.isGrouped = false;
      this.groupedData = [];
    }
  }

  groupData(data: any[], keys: string[]): any[] {
    const groups: { [key: string]: any } = {};
    data.forEach(item => {
      if (item.producttitle === "Grand Total") return;
      const key = keys.map(k => item[k]).join('|');
      if (!groups[key]) {
        const parent: any = { childRows: [], totals: {} };

        keys.forEach(k => {
          parent[k] = item[k];
        });

        Object.keys(item).forEach(k => {
          if (!keys.includes(k) && typeof item[k] === 'number') {
            parent.totals[k] = 0;
          }
        });

        groups[key] = parent;
      }

      const parent = groups[key];
      const child: any = {};

      Object.keys(item).forEach(k => {
        if (!keys.includes(k)) {
          child[k] = item[k];
          if (typeof item[k] === 'number') {
            if (!(k in parent.totals)) parent.totals[k] = 0;
            parent.totals[k] += item[k];
          }
        }
      });

      parent.childRows.push(child);
    });

    return Object.values(groups);
  }

  toggleGrouping() {
    this.isGrouped = !this.isGrouped;

    if (this.isGrouped) {
      this.makeProductGroups();
    } else {
      this.selectedGroupBy = [];
      this.groupedData = [];
    }
  }


  makeProductGroups() {
    const groups: any = {};

    this.filteredData.forEach(item => {
      if (item.producttitle === "Grand Total") return;

      const key = item.sku + "|" + item.producttitle;

      if (!groups[key]) {
        groups[key] = {
          sku: item.sku,
          producttitle: item.producttitle,
          productImage: item.productImage,
          childRows: [],
          totals: { size16XS: 0, sizeL: 0, totalStock: 0 }
        };
      }

      const child = {
        location: item.location,
        color: item.color,
        size16XS: Number(item["16XS"] || 0),
        sizeL: Number(item["l"] || 0),
        totalStock: Number(item.totalStock || 0)
      };

      groups[key].childRows.push(child);

      // update totals inside group
      groups[key].totals.size16XS += child.size16XS;
      groups[key].totals.sizeL += child.sizeL;
      groups[key].totals.totalStock += child.totalStock;
    });

    this.groupedData = Object.values(groups);
    this.originalGroupedData = JSON.parse(JSON.stringify(this.groupedData));
  }

  draggedIndex: number | null = null;

  onDragStart(event: DragEvent, index: number) {
    this.draggedIndex = index;
  }

  onDragOver(event: DragEvent) {
    event.preventDefault(); // Allow drop
  }

  onDrop(event: DragEvent, dropIndex: number) {
    event.preventDefault();
    if (this.draggedIndex === null || this.draggedIndex === dropIndex) return;

    // 🔹 Reorder array
    const movedCol = this.gridColumnDetails[this.draggedIndex];
    this.gridColumnDetails.splice(this.draggedIndex, 1);
    this.gridColumnDetails.splice(dropIndex, 0, movedCol);

    this.draggedIndex = null;
  }


  showSortOptions: boolean = false;
  selectedSortColumns: string[] = [];
  sortedColumn: string | null = null;
  sortDirections: { [key: string]: 'asc' | 'desc' } = {};
  columnSortDirections: { [key: string]: 'asc' | 'desc' } = {};

  toggleSortOptions() {
    this.showSortOptions = !this.showSortOptions;
  }

  toggleSortColumn(event: any, column: string) {
    if (event.target.checked) {
      if (!this.selectedSortColumns.includes(column)) {
        this.selectedSortColumns.push(column);
        this.columnSortDirections[column] = 'asc'; // default asc
      }
    } else {
      this.selectedSortColumns = this.selectedSortColumns.filter(c => c !== column);
      delete this.columnSortDirections[column];
    }
    this.filteredData = this.SortData(this.filteredData);
  }


  toggleColumnDirection(column: string) {
    if (this.columnSortDirections[column] === 'asc') {
      this.columnSortDirections[column] = 'desc';
    } else {
      this.columnSortDirections[column] = 'asc';
    }
    this.filteredData = this.SortDatacheck(this.filteredData);
  }

  SortDatacheck(data: any[]) {
    if (!this.selectedSortColumns.length) return data.slice();

    return data.slice().sort((a, b) => {
      // ✅ Total row check
      if (a.isTotalRow) return 1;   // a ko last bhejo
      if (b.isTotalRow) return -1;  // b ko last bhejo

      for (const col of this.selectedSortColumns) {
        const rawA = a[col] ?? '';
        const rawB = b[col] ?? '';

        let comparison = 0;

        // Date check
        if (col.toLowerCase().includes('date')) {
          const dateA = new Date(rawA).getTime() || 0;
          const dateB = new Date(rawB).getTime() || 0;
          comparison = dateA - dateB;
        }
        // Number check
        else if (!isNaN(parseFloat(rawA)) && !isNaN(parseFloat(rawB))) {
          comparison = parseFloat(rawA) - parseFloat(rawB);
        }
        // String check
        else {
          comparison = rawA.toString().localeCompare(rawB.toString(), undefined, {
            numeric: true,
            sensitivity: 'base'
          });
        }

        if (comparison !== 0) {
          return this.columnSortDirections[col] === 'asc' ? comparison : -comparison;
        }
      }
      return 0;
    });
  }


  applyMultiSort() {
    let data = [...this.filteredData];
    this.selectedSortColumns.forEach(col => {
      this.sortColumn = col;
      this.sortDirection = this.sortDirections[col];
      data = this.SortData(data);
    });
    this.filteredData = data;
  }



  ngOnChanges(changes: SimpleChanges): void {
    if (changes['gridDataDetails'] || changes['gridColumnDetails']) {
      this.initialize();
    }
  };
  isNumeric(value: any): boolean {
    return !isNaN(parseFloat(value)) && isFinite(value);
  };
  formatNumberWithCommasNBracket(value: any): string {
    const num = parseFloat(value);
    if (isNaN(num)) return value.toLocaleString();
    const formatted = Math.abs(num).toLocaleString();
    return num < 0 ? `(${formatted})` : formatted;
  }
  // group function 
  groupBySelectedColumn() {
    const baseData = this.searchedData.length ? this.searchedData : this.gridDataDetails;
    if (!this.selectedGroupColumn) {
      this.filteredData = [...baseData];
      this.showGraphType = false;
      this.showNumericColum = false;
      this.showMakeGraph = false;
      this.applyTotalRow();
      return;
    }
    this.applyGrouping(baseData);
    this.showGraphType = true;
    this.showNumericColum = false;
    this.showMakeGraph = false;
    this.selectedChartType = '';
    this.selectedNumericColumn = '';
    this.selectedDateColumn = '';
  };
  onChartTypeChange() {
    if (this.selectedChartType) {
      this.showNumericColum = true;
      this.showMakeGraph = false;
      this.selectedNumericColumn = '';
      this.selectedDateColumn = '';
    } else {
      this.showNumericColum = false;
      this.showMakeGraph = false;
    }
  };
  onNumericColumnChange() {
    if (this.selectedNumericColumn) {
      this.showMakeGraph = true;
    } else {
      this.showMakeGraph = false;
    }
  }
  applyGrouping(data: any[]) {
    const grouped: any = {};
    data.forEach(row => {
      const key = row[this.selectedGroupColumn] || 'Others';
      if (!grouped[key]) grouped[key] = [];
      grouped[key].push(row);
    });
    const result: any[] = [];
    Object.keys(grouped).forEach(group => {
      const groupRows = grouped[group];
      const groupTotalRow: any = { isTotalRow: true };
      this.gridColumnDetails.forEach(col => {
        if (col.prop === this.selectedGroupColumn) {
          groupTotalRow[col.prop] = group;
        } else {
          const values = groupRows.filter((r: any) => !r[`${col.prop}_excluded`] && !(typeof r[col.prop] === 'string' && r[col.prop].includes('~~'))).map((r: any) => r[col.prop]);
          const isNumeric = values.some((val: any) => !isNaN(parseFloat(val)) && isFinite(val));
          if (isNumeric) {
            const sum = values.reduce((acc: any, val: any) => {
              if (typeof val === 'string' && val.includes('~~')) return acc; // ignore special marker
              const num = parseFloat(val);
              return isNaN(num) ? acc : acc + num;
            }, 0);

            groupTotalRow[col.prop] = sum === 0 ? '' : sum;
          } else {
            groupTotalRow[col.prop] = '';
          }
        }
      });
      result.push(...groupRows, groupTotalRow);
    });
    this.filteredData = result;
    this.showGraphType = true;
  };
  // remove column function 
  removeColumnByName() {
    if (this.removeColumn) {
      this.gridColumnDetails = this.gridColumnDetails.filter(col => col.name.toLowerCase() !== this.removeColumn.toLowerCase());
    }
  };
  // tooltip placement function 
  getTooltipPlacement(row: any, columnProp: string, columnIndex: number): string {
    const value = row[columnProp];
    if (columnIndex === 0) {
      return 'auto';
    } else if (columnIndex === this.gridColumnDetails.length - 1) {
      return 'auto';
    }
    return typeof value === 'number' || !isNaN(parseFloat(value)) ? 'right' : 'left';
  }
  // Function to determine header alignment
  getHeaderAlignment(columnProp: string): string {
    if (
      this.gridDataDetails.length > 0 &&
      this.isNumeric(this.gridDataDetails[0][columnProp])
    ) {
      return 'right';
    }
    return 'left';
  };

  getRowClasses(row: any): string[] {
    const classes = [];
    if (row.rowColor) classes.push(row.rowColor);
    if (row.isTotalRow) classes.push('total-row');
    if (this.highlightNegativeRows && this.hasNegativeValue(row)) {
      classes.push('negative-row');
    }
    return classes;
  }

  // Negative Column value highlight function 
  highlightNegatives: boolean = true;
  highlightNegativeValues(): void {
    this.highlightNegatives = !this.highlightNegatives;
  };
  // Negative Row value highlight function 
  highlightNegativeRows: boolean = false;
  onHighlightNegativeRowsChange(event: Event) {
    const input = event.target as HTMLInputElement;
    this.highlightNegativeRows = input?.checked ?? false;
  }
  hasNegativeValue(row: any): boolean {
    return this.gridColumnDetails.some(col => {
      const val = parseFloat(row[col.prop]);
      return !isNaN(val) && val < 0;
    });
  }
  // single search function 
  filterData() {
    const search = this.searchText ? this.searchText.trim().toLowerCase() : '';

    // 🧹 No search text → reset data
    if (!search) {
      if (this.isGrouped) {
        this.groupedData = JSON.parse(JSON.stringify(this.originalGroupedData));
      } else {
        this.filteredData = [...this.gridDataDetails];
        this.applyTotalRow();
      }
      return;
    }

    // 🧩 If grouped
    if (this.isGrouped) {
      this.groupedData = this.originalGroupedData
        .map(group => {
          const matchedChildren = group.childRows.filter((child: { [s: string]: unknown; } | ArrayLike<unknown>) =>
            Object.values(child).some(val =>
              String(val).toLowerCase().includes(search)
            )
          );

          if (matchedChildren.length > 0) {
            // Keep parent group with matching children
            return { ...group, childRows: matchedChildren };
          }

          // Also match if group header itself matches
          const groupMatches = Object.values(group)
            .some(val => typeof val === 'string' && val.toLowerCase().includes(search));

          if (groupMatches) return { ...group };

          return null;
        })
        .filter(g => g !== null);
    }
    // 🧩 Normal (non-grouped) mode
    else {
      this.filteredData = this.gridDataDetails.filter(row =>
        Object.values(row).some(val =>
          val?.toString().toLowerCase().includes(search)
        )
      );
      this.applyTotalRow();
    }
  }

  // multi search function 
  toggleSearch(e: any) {
    this.showSearch = !this.showSearch;
  };
  searchedData: any[] = [];
  keyupColumnSearch(event: any, prop: string) {
    const val = event.target.value.toLowerCase();
    this.activeFilters = this.activeFilters.filter(f => f.column !== prop);
    if (val) this.activeFilters.push({ column: prop, value: val });
    this.searchedData = this.gridDataDetails.filter(row =>
      this.activeFilters.every(filter =>
        row[filter.column]?.toString().toLowerCase().includes(filter.value)
      )
    );
    // After search, apply grouping if selected
    if (this.selectedGroupColumn) {
      this.applyGrouping(this.searchedData);
    } else {
      this.filteredData = [...this.searchedData];
      this.applyTotalRow();
    }
  };

  normalizeKey(key: string): string {
    return key.replace(/\s+/g, ' ').trim().toLowerCase();
  }

  getColumnKey(target: string): string {
    const normalizedTarget = this.normalizeKey(target);

    const found = Object.keys(this.totalRow).find(k =>
      this.normalizeKey(k) === normalizedTarget
    );
    return found || target;
  }

  // total row function 
  applyTotalRow() {
    this.filteredData = this.filteredData.filter(r => !r.isTotalRow);
    this.totalRow = { isTotalRow: true };
    this.gridColumnDetails.forEach(col => {
      const values = this.filteredData.map(r => r[col.prop]);
      const isNumeric = this.filteredData.some(r =>
        !r[`${col.prop}_excluded`] &&
        !isNaN(parseFloat(r[col.prop])) &&
        isFinite(r[col.prop])
      );
      if (!isNumeric) {
        this.totalRow[col.prop] = '';
      } else {
        const numbers = this.filteredData
          .filter(r => !r[`${col.prop}_excluded`] && !isNaN(parseFloat(r[col.prop])))
          .map(r => parseFloat(r[col.prop]));

        if (numbers.length === 0) {
          this.totalRow[col.prop] = '';
        } else {
          if (col.name.includes('%')) {
            // ✅ Average for percentage columns
            const avg = numbers.reduce((a, b) => a + b, 0) / numbers.length;
            this.totalRow[col.prop] = avg.toFixed(2);
          } else {
            // ✅ Sum for normal numeric columns
            const sum = numbers.reduce((a, b) => a + b, 0);
            this.totalRow[col.prop] = sum;
          }
        }
      }
    });

    const salesKey = this.getColumnKey('sales VALUE (PKR)');
    const directCostKey = this.getColumnKey('direct COST');
    const contributionKey = this.getColumnKey('contribution MARGIN');
    const fohKey = this.getColumnKey('foh');
    const mfgProfitKey = this.getColumnKey('manufacturing PROFIT/(LOSS)');
    const netProfitKey = this.getColumnKey('net PROFIT');

    const totalSalesPKR = parseFloat(this.totalRow[salesKey] || 0);
    const totalDirectCost = parseFloat(this.totalRow[directCostKey] || 0);
    const totalContribution = parseFloat(this.totalRow[contributionKey] || 0);
    const totalFOH = parseFloat(this.totalRow[fohKey] || 0);
    const totalManufacturingProfit = parseFloat(this.totalRow[mfgProfitKey] || 0);
    const totalNetProfit = parseFloat(this.totalRow[netProfitKey] || 0);

    // ✅ Apply Formulas
    if (totalDirectCost && totalSalesPKR) {
      this.totalRow[this.getColumnKey('dc %')] = ((totalDirectCost / totalSalesPKR) * 100).toFixed(2);
    }

    if (totalContribution && totalSalesPKR) {
      this.totalRow[this.getColumnKey('cm %')] = ((totalContribution / totalSalesPKR) * 100).toFixed(2);
    }

    if (totalFOH && totalSalesPKR) {
      this.totalRow[this.getColumnKey('foh %')] = ((totalFOH / totalSalesPKR) * 100).toFixed(2);
    }

    if (totalManufacturingProfit && totalSalesPKR) {
      this.totalRow[this.getColumnKey('manufacturing Profit %')] = ((totalManufacturingProfit / totalSalesPKR) * 100).toFixed(2);
    }

    if (totalNetProfit && totalSalesPKR) {
      this.totalRow[this.getColumnKey('net Profit %')] = ((totalNetProfit / totalSalesPKR) * 100).toFixed(2);
    }

    this.filteredData.push(this.totalRow);
  }
  // width control function 
  calculateColumnWidths() {
    this.columnWidths = this.gridColumnDetails.map(col =>
      Math.max(
        ...this.gridDataDetails.map(r => (r[col.prop]?.toString().length || 0)),
        col.name.length
      ) * 6
    );
  };
  // Last Row total function 
  totalGraphTeam: any[] = [];
  calculateTotalsFortotalGraphTeam() {
    this.totalGraphTeam = [];
    this.gridColumnDetails.forEach(() => {
      this.totalGraphTeam.push('');
    });
    this.totalGraphTeam = this.gridColumnDetails.map(() => 0);
    this.filteredData.forEach(row => {
      this.gridColumnDetails.forEach((col, index) => {
        if (row[`${col.prop}_excluded`]) return;
        const value = parseFloat(row[col.prop]);
        if (!isNaN(value)) this.totalGraphTeam[index] += value;
      });
    });
    this.gridColumnDetails.forEach((col, index) => {
      const allExcludedOrNonNumeric = this.filteredData.every(
        r => r[`${col.prop}_excluded`] || isNaN(parseFloat(r[col.prop]))
      );
      if (allExcludedOrNonNumeric || this.totalGraphTeam[index] === 0) {
        this.totalGraphTeam[index] = '';
      }
    });
    const lastRow = this.filteredData[this.filteredData.length - 1];
    this.gridColumnDetails.forEach((col, index) => {
      let lastValue = lastRow[col.prop];
      if (typeof lastValue === 'string' && lastValue.includes('~~')) {
        lastValue = lastValue.replace('~~', '');
      }
      if (typeof lastValue === 'string' || isNaN(parseFloat(lastValue))) {
        this.totalGraphTeam[index] = '';
      }
    });
  }
  // total click function 
  totalProduction = 0;
  onColumnCellClick(columnKey: string) {
    this.calculateTotalProduction(columnKey);
  }

  isDrilldownMode = false;

  toggleDrilldownMode(): void {
    this.isDrilldownMode = !this.isDrilldownMode;

    const table = document.querySelector('.datatable-body') as HTMLElement;
    if (table) {
      table.style.backgroundColor = this.isDrilldownMode ? '#e3f2fd' : 'transparent';
    }

    console.log(this.isDrilldownMode ? '🔵 Drilldown mode ON' : '⚪ Drilldown mode OFF');
  }

  handleCellClick(row: any, col: any): void {
    if (!this.isDrilldownMode) return;

    const columnName = col.name || col.prop;
    const cellValue = row[col.prop];

    this.cellDrilldown.emit({ column: columnName, value: cellValue });
  }

  calculateTotalProduction(column: string) {
    this.totalProduction = this.filteredData.reduce((sum: number, row: any) => {
      const value = row[column];
      const numericValue = isNaN(parseFloat(value)) ? 0 : parseFloat(value);
      return sum + numericValue / 2;
    }, 0);
  };
  // Sort Function 
  sortColumn: string = '';
  sortDirection: 'asc' | 'desc' = 'asc';
  onSort(column: string) {
    if (this.sortColumn === column) {
      this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
    } else {
      this.sortColumn = column;
      this.sortDirection = 'asc';
    }
    //  CASE 1: Only Group Totals (Summary Rows) are shown
    if (this.showOnlyGroupTotals) {
      const summaryRows = this.filteredData.filter(r => r.isTotalRow);
      const sortedSummaries = this.SortData(summaryRows);
      this.filteredData = sortedSummaries;
      return;
    }
    //  CASE 2: Grouping is active — sort inside each group
    if (this.selectedGroupColumn) {
      const grouped: any = {};
      this.gridDataDetails.forEach(row => {
        const key = row[this.selectedGroupColumn] || 'Others';
        if (!grouped[key]) grouped[key] = [];
        grouped[key].push(row);
      });
      const result: any[] = [];
      Object.keys(grouped).forEach(group => {
        const groupRows = grouped[group].filter((r: any) => !r.isTotalRow);
        const sortedGroup = this.SortData(groupRows);
        const groupTotalRow: any = { isTotalRow: true };
        this.gridColumnDetails.forEach(col => {
          if (col.prop === this.selectedGroupColumn) {
            groupTotalRow[col.prop] = group;
          } else {
            const values = groupRows
              .filter((r: any) =>
                !r[`${col.prop}_excluded`] &&
                !(typeof r[col.prop] === 'string' && r[col.prop].includes('~~')) &&
                !isNaN(parseFloat(r[col.prop]))
              )
              .map((r: any) => parseFloat(r[col.prop]));
            const sum = values.reduce((acc: any, val: any) => acc + val, 0);
            groupTotalRow[col.prop] = values.length && sum !== 0 ? sum : '';
          }
        });
        result.push(...sortedGroup, groupTotalRow);
      });
      this.filteredData = result;
    }
    else {
      const dataWithoutTotal = this.filteredData.filter(r => !r.isTotalRow);
      const totalRow = this.filteredData.find(r => r.isTotalRow);
      const sortedData = this.SortData(dataWithoutTotal);
      this.filteredData = totalRow ? [...sortedData, totalRow] : [...sortedData];
    }
  }

  SortData(data: any[]) {
    return data.slice().sort((a, b) => {
      const valueA = a[this.sortColumn] ?? '';
      const valueB = b[this.sortColumn] ?? '';
      const isDateColumn = this.sortColumn.toLowerCase().includes('date');
      if (isDateColumn) {
        const dateA = new Date(valueA);
        const dateB = new Date(valueB);
        return this.sortDirection === 'asc' ? dateA.getTime() - dateB.getTime() : dateB.getTime() - dateA.getTime();
      }
      if (typeof valueA === 'number' && typeof valueB === 'number') {
        return this.sortDirection === 'asc' ? valueA - valueB : valueB - valueA;
      } else {
        return this.sortDirection === 'asc'
          ? valueA.toString().localeCompare(valueB.toString(), undefined, { numeric: true })
          : valueB.toString().localeCompare(valueA.toString(), undefined, { numeric: true });
      }
    });
  }
  // export excel function 
  exportExcel(): void {
    const element = document.getElementById('printTileDetail');
    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
    XLSX.writeFile(wb, 'TileDetails.xlsx');
  }
  // print function 
  printTable() {
    const content = document.getElementById('printTileDetail')?.innerHTML;
    const printWin = window.open('', '_blank');
    if (printWin && content) {
      printWin.document.open();
      printWin.document.write(`
        <html>
          <head>
            <title>Print</title>
            <style>
              table { width: 100%; border-collapse: collapse; }
              th, td { border: 1px solid #000; padding: 8px; text-align: left; }
              th { background-color: #f2f2f2; }
            </style>
          </head>
          <body onload="window.print();window.close()">${content}</body>
        </html>
      `);
      printWin.document.close();
    }
  };
  showOnlyGroupTotals: boolean = false;
  showGroupTotalsOnly() {
    if (!this.selectedGroupColumn) return;
    this.showOnlyGroupTotals = true;
    this.filteredData = this.filteredData.filter(row => row.isTotalRow);
  };

  showAllRows() {
    this.showOnlyGroupTotals = false;
    if (this.searchedData.length && !this.selectedGroupColumn) {
      this.filteredData = [...this.searchedData];
    } else if (this.selectedGroupColumn) {
      this.applyGrouping(this.searchedData.length ? this.searchedData : this.gridDataDetails);
    } else {
      this.filteredData = [...this.gridDataDetails];
      this.applyTotalRow();
    }
  }
  ShowChart(OrderModal: any) {
    this.modalRef = this.modalService.open(OrderModal, {
      size: 'xl',
      windowClass: 'modal-holder',
      backdrop: 'static'
    });

    this.makeGraph();
  }
  // Numeric Dropdown Function
  get numericColumns() {
    return this.gridColumnDetails.filter(col =>
      this.gridDataDetails.some(row => this.isNumeric(row[col.prop]))
    );
  };
  // Date Dropdown Function
  get dateColumns() {
    const dateRegex = /^\d{2}-[A-Za-z]{3}-\d{2,4}$/;
    return this.gridColumnDetails.filter(col =>
      this.gridDataDetails.every(row => {
        const val = row[col.prop]?.toString().trim();
        if (!val) return true; // allow empty cells
        if (!dateRegex.test(val)) return false;
        const parsedDate = Date.parse(val.replace(/-/g, ' '));
        return !isNaN(parsedDate);
      })
    );
  }
  // Make Graph Function 
  summaryTableHeaders: string[] = [];
  summaryTableData: any[] = [];

  makeGraph() {
    if (!this.selectedGroupColumn || !this.selectedNumericColumn) return;

    // Table headers
    this.summaryTableHeaders = [
      this.selectedGroupColumn,
      this.selectedNumericColumn,
      'Percentage'
    ];
    if (this.selectedDateColumn) this.summaryTableHeaders.push(this.selectedDateColumn);

    // Reset table & chart
    this.summaryTableData = [];
    this.showChart = true;

    // Helper: remove any pre-existing "total" rows
    const cleanRows = (rows: any[]) =>
      rows.filter(r => {
        if (!r) return false;
        if (r.isTotalRow) return false;
        const g = (r[this.selectedGroupColumn] ?? '').toString().toLowerCase();
        if (g.includes('total')) return false;
        return true;
      });

    // Select correct base data
    let baseData: any[] = [];
    if (this.isGrouped && this.groupedData?.length) {
      //baseData = this.groupedData.flatMap((g: any) => g.childRows || []);
      baseData = this.groupedData.reduce((acc: any[], g: any) => {
        return acc.concat(g.childRows || []);
      }, []);

    } else if (this.filteredData?.length) {
      baseData = cleanRows(this.filteredData);
    } else if (this.searchedData?.length) {
      baseData = cleanRows(this.searchedData);
    } else {
      baseData = cleanRows(this.gridDataDetails || []);
    }

    if (!baseData.length) {
      this.chartOptions = { series: [], chart: { height: 400, type: 'bar' } } as any;
      return;
    }

    // ---- Build grouped totals ----
    const groupMap: Record<string, { totalValue: number; children: any[] }> = {};
    baseData.forEach(row => {
      const groupName = (row[this.selectedGroupColumn] ?? '').toString();
      const value = Number(row[this.selectedNumericColumn]);

      if (!groupMap[groupName]) {
        groupMap[groupName] = { totalValue: 0, children: [] };
      }

      groupMap[groupName].totalValue += value;
      groupMap[groupName].children.push(row);
    });

    // Summary table & grand total
    let grandTotal = 0;
    this.summaryTableData = [];

    Object.keys(groupMap).forEach(groupName => {
      const item = groupMap[groupName];
      grandTotal += item.totalValue;

      // Parent Row
      this.summaryTableData.push({
        group: groupName,
        value: item.totalValue,
        percentage: (item.totalValue / grandTotal) * 100
      });

      // Child rows could also be shown if needed
    });

    // Total row
    this.summaryTableData.push({
      group: 'Total',
      value: grandTotal,
      percentage: null
    });

    // ---- Build chart records ----
    const records: Array<{ group: string; value: number }> = Object.keys(groupMap).map(
      name => ({ group: name, value: groupMap[name].totalValue })
    );

    // ---- Build chart ----
    const labels = records.map(r => r.group ?? '');
    const data = records.map(r => Number(r.value) || 0);

    this.chartOptions = {
      series: this.selectedChartType === 'Pie'
        ? data
        : [{ name: this.selectedNumericColumn, data }],
      chart: { type: (this.selectedChartType || 'bar').toLowerCase(), height: 400 },
      labels: this.selectedChartType === 'Pie' ? labels : undefined,
      xaxis: this.selectedChartType !== 'Pie' ? { categories: labels } : undefined,
      title: { text: `Chart of ${this.selectedNumericColumn}` },
      dataLabels: { enabled: true }
    };
  }


  summarySortColumn: string = '';
  summarySortDirection: 'asc' | 'desc' = 'asc';
  onSummarySort(column: string) {
    if (this.summarySortColumn === column) {
      this.summarySortDirection = this.summarySortDirection === 'asc' ? 'desc' : 'asc';
    } else {
      this.summarySortColumn = column;
      this.summarySortDirection = 'asc';
    }
    // Separate total row from data
    const dataWithoutTotal = this.summaryTableData.filter(row => row.group !== 'Total');
    const totalRow = this.summaryTableData.find(row => row.group === 'Total');
    // Perform sorting
    dataWithoutTotal.sort((a, b) => {
      const valA = a[column] ?? '';
      const valB = b[column] ?? '';
      const isNumeric = !isNaN(parseFloat(valA)) && !isNaN(parseFloat(valB));
      const isDate = column === 'date' && !isNaN(Date.parse(valA)) && !isNaN(Date.parse(valB));
      if (isDate) {
        const dateA = new Date(valA).getTime();
        const dateB = new Date(valB).getTime();
        return this.summarySortDirection === 'asc' ? dateA - dateB : dateB - dateA;
      }
      if (isNumeric) {
        return this.summarySortDirection === 'asc'
          ? parseFloat(valA) - parseFloat(valB)
          : parseFloat(valB) - parseFloat(valA);
      }
      return this.summarySortDirection === 'asc'
        ? valA.toString().localeCompare(valB.toString(), undefined, { numeric: true })
        : valB.toString().localeCompare(valA.toString(), undefined, { numeric: true });
    });
    this.summaryTableData = totalRow ? [...dataWithoutTotal, totalRow] : dataWithoutTotal;
  }
  calculatePercentage(value: number): string {
    const totalRow = this.summaryTableData.find(row => row.group === 'Total');
    const totalValue = totalRow?.value ?? 0;
    if (totalValue === 0 || value == null) return '0%';
    const percentage = (value / totalValue) * 100;
    return percentage.toFixed(2) + '%';
  }

  // Helper function
  calculateDcPercentage(row: any): number | null {

    const directCost = row['direct COST       '];

    const salesValue = row['sales VALUE (PKR)         '];


    if (directCost != null && salesValue != null && salesValue !== 0) {
      return (directCost / salesValue) * 100;

    }

    return null;
  }


}